import angular from 'angular';
import { CreateApplicationService } from 'modules/application/create/CreateApplicationService';
import { Contexts, } from 'modules/core/ContextProcessorService';
import { applicationListStateName } from 'modules/application/list';
import { InitialSetupController } from './InitialSetupController';
import { IntroductionStepController } from './steps/introduction/introductionStepController';
import { MembersStepController } from './steps/members/membersStepController';
import { ApplicationStepController } from './steps/application/applicationStepController';
import InitialSetupView from './InitialSetupView.html';
import IntroductionStepView from './steps/introduction/introductionStepView.html';
import MembersStepView from './steps/members/membersStepView.html';
import ApplicationStepView from './steps/application/applicationStepView.html';
export const initialSetupStateName = 'auth.initialSetup';
export const initialSetupStateNamePrefix = 'auth.initialSetup.';
export const initialSetupIntroductionStateName = initialSetupStateNamePrefix + 'introduction';
export const initialSetupMembersStateName = initialSetupStateNamePrefix + 'members';
export const initialSetupApplicationStateName = initialSetupStateNamePrefix + 'application';
export default angular
    .module('initialSetup', ['ui.router'])
    .service('ApplicationCreationService', CreateApplicationService)
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state(initialSetupStateName, {
            url: '/initial-setup',
            views: {
                '@': {
                    controller: InitialSetupController,
                    controllerAs: '$ctrl',
                    template: InitialSetupView,
                },
            },
            redirectTo: initialSetupIntroductionStateName,
            resolve: {
                authorization: fetchInitialSetupPermission,
            },
        })
            .state(initialSetupIntroductionStateName, {
            url: '/introduction',
            template: IntroductionStepView,
            controllerAs: '$ctrl',
            controller: IntroductionStepController,
            resolve: {
                authorization: fetchInitialSetupPermission,
            },
        })
            .state(initialSetupMembersStateName, {
            url: '/members',
            template: MembersStepView,
            controllerAs: '$ctrl',
            controller: MembersStepController,
            resolve: {
                authorization: fetchInitialSetupPermission,
            },
        })
            .state(initialSetupApplicationStateName, {
            url: '/application',
            template: ApplicationStepView,
            controllerAs: '$ctrl',
            controller: ApplicationStepController,
            resolve: {
                authorization: fetchInitialSetupPermission,
            },
        });
    }])
    .run(['AccountService2', 'ContextProcessorService', 'BlipToastService', '$rootScope', '$state', '$translate', function (AccountService2, ContextProcessorService, BlipToastService, $rootScope, $state, $translate) {
        $rootScope.$on('$stateChangeStart', async (_, toState, __, fromState) => {
            await ContextProcessorService.waitForInitialization();
            if (toState.name.startsWith(initialSetupStateNamePrefix)) {
                await onEnteringOrNavigatingInitialSetup($state, AccountService2, ContextProcessorService, toState);
                return;
            }
            if (fromState.name.startsWith(initialSetupStateName) && !toState.name.startsWith(initialSetupStateName)) {
                await onLeavingInitialSetup(AccountService2, BlipToastService, $rootScope, $translate);
                return;
            }
            if (!toState.name.startsWith(initialSetupStateName)) {
                await onNavigatingOutOfInitialSetup(AccountService2, ContextProcessorService, $state);
                return;
            }
        });
    }]).name;
const fetchInitialSetupPermission = ['$state', 'ContextProcessorService', async function ($state, ContextProcessorService) {
        await ContextProcessorService.waitForInitialization();
        const isOnTenantContext = ContextProcessorService.context === Contexts.Tenants;
        if (!isOnTenantContext) {
            $state.go(applicationListStateName);
        }
    }];
const onEnteringOrNavigatingInitialSetup = async ($state, AccountService2, ContextProcessorService, toState) => {
    const account = await AccountService2.me();
    if (account.extras?.initialSetupDone == 'true') {
        $state.go(applicationListStateName);
        return;
    }
    setTimeout(async () => {
        await AccountService2.setExtras({
            ...account.extras,
            initialSetupStep: toState.name,
            initialSetupTenant: ContextProcessorService.tenant.id,
        });
    }, 500);
};
const onLeavingInitialSetup = async (AccountService2, BlipToastService, $rootScope, $translate) => {
    const account = await AccountService2.me();
    if (account.extras?.initialSetupDone == 'true') {
        return;
    }
    // Removes the keys 'initialSetupStep' and 'initialSetupTenant' from the extras
    const { initialSetupStep, initialSetupTenant, ...noSetupExtras } = account.extras;
    setTimeout(async () => {
        await AccountService2.setExtras({
            ...noSetupExtras,
            initialSetupDone: 'true',
        });
    }, 500);
    if ($rootScope.initialSetupApplicationCreated) {
        BlipToastService.show('success', {
            title: await $translate('initialSetup.successToast.title'),
            msg: await $translate('initialSetup.successToast.message'),
        });
    }
    else {
        BlipToastService.show('success', {
            title: await $translate('initialSetup.successToastSkip.title'),
            msg: await $translate('initialSetup.successToastSkip.message'),
        });
    }
};
const onNavigatingOutOfInitialSetup = async (AccountService2, ContextProcessorService, $state) => {
    const account = await AccountService2.me();
    const initialSetupDone = account.extras?.initialSetupDone;
    const initialSetupStep = account?.extras?.initialSetupStep;
    const initialSetupTenant = account?.extras?.initialSetupTenant;
    if (initialSetupDone !== 'true' &&
        initialSetupStep &&
        ContextProcessorService.context == Contexts.Tenants &&
        ContextProcessorService.tenant.id == initialSetupTenant) {
        $state.go(initialSetupStep);
    }
};
